import { RefString, RefDate, RefNumber } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { PersonalPickupStepState } from "../../PersonalPickup/Models/PersonalPickupStepState";
import { PersonalReturnStepRawData } from "./PersonalReturnStepRawData";


export class PersonalReturnStepData extends StepData
{
    public MeetingPlace = new RefString();
    public PlannedMeetingTime = new RefDate(new Date(0));
    public MeetingTime = new RefDate(new Date(0));
    public CashToReturn = new RefNumber();
    public ExtraCashToPay = new RefNumber();
   
    constructor(raw: Partial<PersonalReturnStepRawData>)
    {
        super(raw);

        this.State.value ||= PersonalPickupStepState.NotPlannedYet;

        this.MeetingPlace.value = raw?.MeetingPlace || "";
        this.PlannedMeetingTime.value = new Date(raw?.PlannedMeetingTime || 0);
        this.MeetingTime.value = new Date(raw?.MeetingTime || 0);
        this.CashToReturn.value = raw?.CashToReturn || 0;
        this.ExtraCashToPay.value = raw?.ExtraCashToPay || 0;
    }
}
